import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _createForOfIteratorHelper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestyleediting
 */
import { Plugin } from 'ckeditor5/src/core';
import ImageStyleCommand from './imagestylecommand';
import ImageUtils from '../imageutils';
import utils from './utils';
import { viewToModelStyleAttribute, modelToViewStyleAttribute } from './converters';
/**
 * The image style engine plugin. It sets the default configuration, creates converters and registers
 * {@link module:image/imagestyle/imagestylecommand~ImageStyleCommand ImageStyleCommand}.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageStyleEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageStyleEditing, _Plugin);

  var _super = _createSuper(ImageStyleEditing);

  function ImageStyleEditing() {
    _classCallCheck(this, ImageStyleEditing);

    return _super.apply(this, arguments);
  }

  _createClass(ImageStyleEditing, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var normalizeStyles = utils.normalizeStyles,
          getDefaultStylesConfiguration = utils.getDefaultStylesConfiguration;
      var editor = this.editor;
      var isBlockPluginLoaded = editor.plugins.has('ImageBlockEditing');
      var isInlinePluginLoaded = editor.plugins.has('ImageInlineEditing');
      editor.config.define('image.styles', getDefaultStylesConfiguration(isBlockPluginLoaded, isInlinePluginLoaded));
      /**
       * It contains a list of the normalized and validated style options.
       *
       * * Each option contains a complete icon markup.
       * * The style options not supported by any of the loaded image editing plugins (
       * {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`} or
       * {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`}) are filtered out.
       *
       * @protected
       * @readonly
       * @type {module:image/imagestyle~ImageStyleConfig}
       */

      this.normalizedStyles = normalizeStyles({
        configuredStyles: editor.config.get('image.styles'),
        isBlockPluginLoaded: isBlockPluginLoaded,
        isInlinePluginLoaded: isInlinePluginLoaded
      });

      this._setupConversion(isBlockPluginLoaded, isInlinePluginLoaded);

      this._setupPostFixer(); // Register imageStyle command.


      editor.commands.add('imageStyle', new ImageStyleCommand(editor, this.normalizedStyles));
    }
    /**
     * Sets the editor conversion taking the presence of
     * {@link module:image/image/imageinlineediting~ImageInlineEditing `ImageInlineEditing`}
     * and {@link module:image/image/imageblockediting~ImageBlockEditing `ImageBlockEditing`} plugins into consideration.
     *
     * @private
     * @param {Boolean} isBlockPluginLoaded
     * @param {Boolean} isInlinePluginLoaded
     */

  }, {
    key: "_setupConversion",
    value: function _setupConversion(isBlockPluginLoaded, isInlinePluginLoaded) {
      var editor = this.editor;
      var schema = editor.model.schema;
      var modelToViewConverter = modelToViewStyleAttribute(this.normalizedStyles);
      var viewToModelConverter = viewToModelStyleAttribute(this.normalizedStyles);
      editor.editing.downcastDispatcher.on('attribute:imageStyle', modelToViewConverter);
      editor.data.downcastDispatcher.on('attribute:imageStyle', modelToViewConverter); // Allow imageStyle attribute in image and imageInline.
      // We could call it 'style' but https://github.com/ckeditor/ckeditor5-engine/issues/559.

      if (isBlockPluginLoaded) {
        schema.extend('imageBlock', {
          allowAttributes: 'imageStyle'
        }); // Converter for figure element from view to model.

        editor.data.upcastDispatcher.on('element:figure', viewToModelConverter, {
          priority: 'low'
        });
      }

      if (isInlinePluginLoaded) {
        schema.extend('imageInline', {
          allowAttributes: 'imageStyle'
        }); // Converter for the img element from view to model.

        editor.data.upcastDispatcher.on('element:img', viewToModelConverter, {
          priority: 'low'
        });
      }
    }
    /**
     * Registers a post-fixer that will make sure that the style attribute value is correct for a specific image type (block vs inline).
     *
     * @private
     */

  }, {
    key: "_setupPostFixer",
    value: function _setupPostFixer() {
      var editor = this.editor;
      var document = editor.model.document;
      var imageUtils = editor.plugins.get(ImageUtils);
      var stylesMap = new Map(this.normalizedStyles.map(function (style) {
        return [style.name, style];
      })); // Make sure that style attribute is valid for the image type.

      document.registerPostFixer(function (writer) {
        var changed = false;

        var _iterator = _createForOfIteratorHelper(document.differ.getChanges()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var change = _step.value;

            if (change.type == 'insert' || change.type == 'attribute' && change.attributeKey == 'imageStyle') {
              var element = change.type == 'insert' ? change.position.nodeAfter : change.range.start.nodeAfter;

              if (element && element.is('element', 'paragraph') && element.childCount > 0) {
                element = element.getChild(0);
              }

              if (!imageUtils.isImage(element)) {
                continue;
              }

              var imageStyle = element.getAttribute('imageStyle');

              if (!imageStyle) {
                continue;
              }

              var imageStyleDefinition = stylesMap.get(imageStyle);

              if (!imageStyleDefinition || !imageStyleDefinition.modelElements.includes(element.name)) {
                writer.removeAttribute('imageStyle', element);
                changed = true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return changed;
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'ImageStyleEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [ImageUtils];
    }
  }]);

  return ImageStyleEditing;
}(Plugin);

export { ImageStyleEditing as default };